import React from 'react';
import {noop} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ORDER_HISTORY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import withRecordPopover from '../withRecordPopover';

import {AllFrontlineClientsContent} from './AllFrontlineClientsContent';
import reportPayload from './reportPayload';

interface AllFrontlineClientsReportProps {
  tt: (key: string, defaultValue?: string) => string;
  showRecordPopover: () => void;
  loadingData: {
    total?: number;
  };
}

export const AllFrontlineClientsReport = ({
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = noop,
  loadingData = {},
}: AllFrontlineClientsReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'All Frontline Clients')}
      description={tt(
        'description',
        'All Clients in your Frontline (could include your personally sponsored Coaches too).',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={AllFrontlineClientsContent}
    />
  );
};

export default withHOC(
  withTranslation('report.allFrontlineClients'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ORDER_HISTORY,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.orderHistory', 'Order History'),
    },
  }),
)(AllFrontlineClientsReport);
